// TODO: remove when idx-js provides type information
export function isRawIdxResponse(obj) {
    return obj && obj.version;
}
